import gql from 'graphql-tag';

export const TESTATOR_DOCUMENT_FRAGMENT = gql`
  fragment TestatorDocumentFields on TestatorDocument {
    id
    type
    displayName
    category
    name
    notes
    originalLocation
    multiInstance
    expiryMonths
    optional
    capturesOriginalLocation
    createdAt
    updatedAt
    files {
      id
      originalFilename
      friendlyFilename
      contentType
      byteSize
      createdAt
    }
  }
`;

export const UPDATE_TESTATOR_DOCUMENT_MUTATION = gql`
  ${TESTATOR_DOCUMENT_FRAGMENT}
  mutation updateTestatorDocument($id: ID!, $name: String, $notes: String) {
    updateTestatorDocument(id: $id, name: $name, notes: $notes) {
      ...TestatorDocumentFields
    }
  }
`;

export const UPDATE_TESTATOR_DOCUMENT_LOCATION_MUTATION = gql`
  ${TESTATOR_DOCUMENT_FRAGMENT}
  mutation updateTestatorDocument($id: ID!, $originalLocation: String) {
    updateTestatorDocument(id: $id, originalLocation: $originalLocation) {
      ...TestatorDocumentFields
    }
  }
`;

export const DELETE_TESTATOR_DOCUMENT_MUTATION = gql`
  mutation deleteTestatorDocument($id: ID!) {
    deleteTestatorDocument(id: $id) {
      id
    }
  }
`;

export const DELETE_TESTATOR_DOCUMENT_FILE_MUTATION = gql`
  mutation deleteTestatorDocumentFile($id: ID!) {
    deleteTestatorDocumentFile(id: $id) {
      id
    }
  }
`;

export const RESTORE_TESTATOR_DOCUMENT_MUTATION = gql`
  ${TESTATOR_DOCUMENT_FRAGMENT}
  mutation restoreTestatorDocument($id: ID!) {
    restoreTestatorDocument(id: $id) {
      ...TestatorDocumentFields
    }
  }
`;

export const CREATE_TESTATOR_DOCUMENT_FILE_PRESIGNED_URL_MUTATION = gql`
  mutation createTestatorDocumentFilePresignedUrl($id: ID!) {
    createTestatorDocumentFilePresignedUrl(id: $id)
  }
`;
